module.exports = __webpack_public_path__ + "static/img/chang.75d4d2c4.png";